import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import MachadaloDashboard from '../machadaloDashboard';

export default function MachadaloRoutes() {
  return (
    <>
      <Routes>
        <Route exact path={'/'} element={<MachadaloDashboard />} />
      </Routes>
    </>
  );
}
